import React from 'react';
import { FormikValues, FormikSharedConfig } from 'formik';
import { StudentLoginType, GroupCreate } from 'types/schema-generated-types';

export type LicenseAssignFn = (
  productFamilyId: number,
  productCurriculumId: number,
  studentId: number
) => void;

export type LicenseUnassignFn = (
  productFamilyId: number,
  productCurriculumId: number,
  studentId: number
) => void;

export interface ProductImage {
  productKey: string;
  name: string;
}

export interface RowData {
  expansionComponent?: React.ReactNode;
}

export interface StudentData<T = ProductImage> extends RowData {
  id: number;
  firstName: string;
  lastName: string;
  password: string;
  username?: string;
  email?: string;
  gradeLevel: string | number;
  products?: Array<T>;
}

export interface ClassroomData {
  id?: number;
  name?: string;
  users?: Array<{
    user?: {
      firstName?: string;
      lastName?: string;
    };
    classroomRoles?: Array<{
      name?: string;
    }>;
  }>;
}

export interface ClassroomRowData extends RowData, ClassroomData {}

export enum ClassroomModalVariant {
  EDIT = 'EDIT',
  CREATE = 'CREATE',
  ARCHIVE = 'ARCHIVE',
  DELETE = 'DELETE',
  ADD_STUDENT = 'ADD_STUDENT',
  MANAGE_CLASSROOM_SETTNGS = 'MANAGE_CLASSROOM_SETTNGS',
  MANAGE_CLASSROOM_PRODUCTS = 'MANAGE_CLASSROOM_PRODUCTS'
}

export enum ClassroomModalRouteAction {
  EDIT_CLASSROOM = 'edit-class',
  CREATE_CLASSROOM = 'create-class',
  ARCHIVE_CLASSROOMS = 'archive-classes',
  DELETE_CLASSROOMS = 'delete-classes',
  MANAGE_CLASSROOM_PRODUCTS = 'manage-class-products',
  MANAGE_CLASSROOM_SETTINGS = 'manage-class-settings',
  ADD_STUDENTS = 'add-students',
  EDIT_STUDENT = 'edit-student',
  EDIT_STUDENT_PRODUCTS = 'edit-student-products',
  EDIT_STUDENT_SETTINGS = 'edit-student-settings',
  PRINT_STUDENT_LOGIN_CARDS = 'print-student-login-cards',
  PRINT_STUDENT_CERTIFICATES = 'print-student-certificates',
  TRANSFER_STUDENT = 'transfer-student'
}

export interface Step extends FormikSharedConfig<FormikValues> {
  id: string;
  validate?: (values: FormikValues) => object;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validationSchema?: any | (() => any);
}

export interface CreateClassStepForm {
  name: string;
  organization: string;
  educator: string;
  schoolYear: string;
  secretCodeType: StudentLoginType;
  color: string;
  coeducators: Array<any>;
  groups?: GroupCreate[];
}

export type License = {
  productCurriculumId: number;
  productFamilyId: number;
};

export type BaseStudentFormEntry = {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  gradeLevel?: string;
  licenses?: Array<License>;
  group?: GroupCreate;
};

export type StudentFormEntry = BaseStudentFormEntry & {
  id: number;
  secretCode?: { loginType: StudentLoginType; code: string } | null;
};

export interface AddStudentsStepForm {
  students: StudentFormEntry[];
}

export type Form = AddStudentsStepForm | CreateClassStepForm | object;
export type FormIndex = 'ADD_STUDENTS' | 'CREATE_CLASS';

export interface CreateClassroomForm {
  ADD_STUDENTS: AddStudentsStepForm;
  CREATE_CLASS: CreateClassStepForm;
}

export enum ProductAssignmentMode {
  'CLASS' = 'CLASS',
  'STUDENT' = 'STUDENT'
}

export interface AddStudentsForm {
  ADD_STUDENTS: AddStudentsStepForm;
  CREATE_CLASS: CreateClassStepForm;
}

export enum ClassroomFilterValue {
  ACTIVE = 'active',
  ARCHIVE = 'archive'
}

export enum RemoveVariant {
  ARCHIVE = 'ARCHIVE',
  DELETE = 'DELETE'
}

export interface StudentFieldProps {
  index: number;
  touched?: boolean;
}
